import Heading from 'components/Basic/Heading/Heading';
import useTranslation from 'next-translate/useTranslation';
import Skeleton from 'react-loading-skeleton';
import { twJoin } from 'tailwind-merge';

const skeletonBaseTwClass = 'h-full w-full';
const productSkeletonContainerBaseTwClass = 'h-64 w-full';
const productSkeletonLgContainerTwClass = 'hidden lg:block';
const productSkeletonXlContainerTwClass = 'hidden xl:block';

export const ProductLineSkeleton: FC = () => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col space-y-4 pb-8 vl:space-y-8 vl:bg-grayLight vl:pl-12 vl:pr-12 vl:pt-3">
            <Heading type="h3">{t('Product line')}</Heading>
            <div className="space-between flex h-48 w-full space-x-8 vl:space-x-16">
                <Skeleton className={skeletonBaseTwClass} containerClassName="h-full w-1/3" />
                <Skeleton className={skeletonBaseTwClass} containerClassName="h-full w-2/3" />
            </div>
            <Skeleton className={skeletonBaseTwClass} containerClassName="h-24 w-full" />
            <div className="grid w-full grid-cols-2 gap-10 self-center lg:grid-cols-4 xl:grid-cols-6">
                <Skeleton className={skeletonBaseTwClass} containerClassName={productSkeletonContainerBaseTwClass} />
                <Skeleton className={skeletonBaseTwClass} containerClassName={productSkeletonContainerBaseTwClass} />
                <Skeleton
                    className={skeletonBaseTwClass}
                    containerClassName={twJoin(productSkeletonContainerBaseTwClass, productSkeletonLgContainerTwClass)}
                />
                <Skeleton
                    className={skeletonBaseTwClass}
                    containerClassName={twJoin(productSkeletonContainerBaseTwClass, productSkeletonLgContainerTwClass)}
                />
                <Skeleton
                    className={skeletonBaseTwClass}
                    containerClassName={twJoin(productSkeletonContainerBaseTwClass, productSkeletonXlContainerTwClass)}
                />
                <Skeleton
                    className={skeletonBaseTwClass}
                    containerClassName={twJoin(productSkeletonContainerBaseTwClass, productSkeletonXlContainerTwClass)}
                />
            </div>
        </div>
    );
};
